export const ALERT_SEVERITY = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
};

export const OVERRIDE_STYLE = {
  NSR: {
    color: '#000000',
    backgroundColor: '#9DD3DE',
    'margin-bottom': '10px',
  },
};

export const ALERT_MSG = {
  NSR_INFO:
    'New! The Normal Kardia Determination is now displayed as Normal Sinus Rhythm.',
};



// WEBPACK FOOTER //
// ./src/views/components/Common/AlertBar/Constants.js